var React = require('react');
var ReactNative = require('react-native');


var Animated = require('./wrappers/Animated')

import Icon from './wrappers/ReUpIcon';
// var Communications = require('react-native-communications');
var PhoneManager = require('./wrappers/PhoneManager-wrapper');
var LinkingManager = require('./wrappers/LinkingManager');
// var url = "https://www.google.com/maps?q="+location.Address.Latitude+","+location.Address.Longitude
var Globals = require('./Globals');
var ModelConstants = require('./constants/ModelConstants.js');
var ReUpScrollView = require('./ReUpScrollView.js');
var ReUpText = require('./ReUpText');
var MapView = require('./wrappers/react-native-maps-wrapper');

var MK = require('./wrappers/react-native-material-kit-wrapper');

var ReUpButton = require('./ReUpButton');

var {
  MKColor,
  MKCardStyles,
  MKTextField,
  MKButton,
} = MK;

var {
  AppRegistry,
  Text,
  View,
  Image,
  ScrollView,
  DeviceEventEmitter,
  StyleSheet,
  Platform,
} = ReactNative;

var LOCATION_UPDATE_CD = 500;

function titleCase(str) 
{
   var splitStr = str.toLowerCase().split(' ');
   for (var i = 0; i < splitStr.length; i++) {
       // You do not need to check if i is larger than splitStr length, as your for does that for you
       // Assign it back to the array
       splitStr[i] = splitStr[i].charAt(0).toUpperCase() + splitStr[i].substring(1);     
   }
   // Directly return the joined string
   return splitStr.join(' '); 
}

var Locations = require("create-react-class")(
{
  getDefaultProps : function()
  {
    return {
      appManager : null,
    }
  },

  getInitialState : function()
  {
    return {
      layout : this.props.initialLayout,
      locations : [],
      region : {latitude:0,longitude:0,latitudeDelta:0,longitudeDelta:0},
      selectedLocation : null,
      currentPosition: this.props.appManager.getCurrentPosition(),
      markers : [],
      showingAll : false,
    }
  },

  componentDidMount : function()
  {
    this.didUpdate();

    var thisThing = this;
    this.props.appManager.updateCurrentPosition(()=>
    {
      // if location is different, then do an update
      if( thisThing._ptr ) thisThing._ptr.doOnlineUpdate()
    });
  },

  didUpdate : function(data)
  {
    var thisThing = this;

    if( typeof data === 'undefined' )
    {
      // var thisThing = this;
      // this.props.appManager.getDataType("Locations", function(data)
      // {
      //   var oldLocations = thisThing.state.locations;
      //   var oldSelectedLocation = thisThing.state.selectedLocation;
      //   var newSelectedLocation = data.length > 0 ? data[0] : null;
      //   if( oldSelectedLocation != null )
      //   {
      //     for( var i = 0; i < data.length; i++ )
      //     {
      //       var thisLoc = data[i];
      //       if( thisLoc.LocationID == oldSelectedLocation.LocationID )
      //       {
      //         newSelectedLocation = thisLoc;
      //         break;
      //       }
      //     }
      //   }
      //   thisThing.setState({locations:data, selectedLocation: newSelectedLocation});
      // })
      if( this.state.locations.length > 0 && this.state.selectedLocation == null )
      {
        this.didSelectLocation(this.state.locations[0]);
      }
    }
    else if(typeof data.Locations !== 'undefined' )
    {
      var oldLocations = this.state.locations;
      var oldSelectedLocation = this.state.selectedLocation;
      var locations = data.Locations;
      var filteredLocations = [];
      var markers = [];
      var addedLocationIDs = [];
      for( var i = 0; i < locations.length; i++ )
      {
        var location = locations[i];
        if( addedLocationIDs.indexOf(location.LocationID) > -1) continue;

        if ( location.IsDeleted != "1" || location.IsDisabled != "1" )
        {
          addedLocationIDs.push(location.LocationID);
          location.distance = thisThing.calculateDistance(location.Latitude, location.Longitude, thisThing.state.currentPosition.latitude, thisThing.state.currentPosition.longitude);
          markers.push(
            {
              latlng : {
                latitude:parseFloat(location.Latitude),
                longitude:parseFloat(location.Longitude)
              },
              title:location.Name,
              description:location.Description
            }
          )
          filteredLocations.push(location);
        }
      }
      locations = filteredLocations;
      // var locations = data.Locations.sort(function(a,b)
  		// {
  		// 	return a.Name.localeCompare(b.Name);
  		// })
      // var newSelectedLocation = locations.length > 0 ? locations[0] : this.state.selectedLocation;
      // if( oldSelectedLocation != null )
      // {
      //   for( var i = 0; i < locations.length; i++ )
      //   {
      //     var thisLoc = locations[i];
      //     if( thisLoc.LocationID == oldSelectedLocation.LocationID )
      //     {
      //       newSelectedLocation = thisLoc;
      //       break;
      //     }
      //   }
      // }
      // var selectedRegion;
      // if( newSelectedLocation != null )
      // {
      //   var latitude = parseFloat(newSelectedLocation.Latitude);
      //   var longitude = parseFloat(newSelectedLocation.Longitude);
      //
      //   selectedRegion =
      //   {
      //     latitude:latitude,
      //     longitude:longitude,
      //     latitudeDelta:0.002,
      //     longitudeDelta:0.002,
      //   }
      // }

      var sortedLocations = locations.sort(function(a,b)
      {
        if( a.distance == b.distance ) return a.Name.localeCompare(b.Name);

        return parseFloat(a.distance) - parseFloat(b.distance);
      });

      thisThing.setState({locations:sortedLocations, markers});
    }
    else
    {
      // if( this.state.locations.length > 0 && this.state.selectedLocation == null )
      // {
      //   this.didSelectLocation(this.state.locations[0]);
      // }
    }
  },

  didSelectLocation: function(location)
  {
    var latitude = parseFloat(location.Latitude);
    var longitude = parseFloat(location.Longitude);

    var selectedRegion = {
      latitude:latitude,
      longitude:longitude,
      latitudeDelta:.002,
      longitudeDelta:.002,
    }

    this.setState({region:selectedRegion, selectedLocation:location});
  },

  callLocation: function(location)
  {
    PhoneManager.call(location.Phone)
  },

  openMaps: function(location)
  {
    var url = "https://www.google.com/maps?q="+location.Latitude+","+location.Longitude;
    var barTintColor = this.props.appManager.getColorForKey("HeaderColor");
    var tintColor = this.props.appManager.getColorForKey("HeaderIconColor");
    LinkingManager.openURL(url, tintColor, barTintColor);
  },

  onRegionChange: function(region)
  {
    this.state.region = region;
  },

  calculateDistance: function (lat1, lon1, lat2, lon2) {
    var radlat1 = Math.PI * lat1/180
    var radlat2 = Math.PI * lat2/180
    var theta = lon1-lon2
    var radtheta = Math.PI * theta/180
    var dist = Math.sin(radlat1) * Math.sin(radlat2) + Math.cos(radlat1) * Math.cos(radlat2) * Math.cos(radtheta);
    dist = Math.acos(dist)
    dist = dist * 180/Math.PI
    dist = dist * 60 * 1.1515
    return dist.toFixed(2)
  },

  render: function()
  {
    var thisThing = this;

    if( (this.state.locations.length > 0 && this.state.selectedLocation == null) )
    {
      this.didSelectLocation(this.state.locations[0]);
    }
    else if( typeof this.state.region !== 'undefined' && this.state.region.longitudeDelta <= 0 && this.state.selectedLocation != null )
    {
      this.didSelectLocation(this.state.selectedLocation);
    }
    var thisLocations = this;
    var appManager = this.props.appManager;
    var locManager = this.props.appManager.getLocalizationManager();
    var user = appManager.currentUser();
    var locations = this.state.locations;

    var instructionColor = appManager.getColorForKey("InstructionColor");
    var instructionTitleColor = appManager.getColorForKey("InstructionTitleColor");
    var generalColor = appManager.getColorForKey("GeneralColor");
    var generalTitleColor = appManager.getColorForKey("GeneralTitleColor");
    var secondaryButtonColor = appManager.getColorForKey("ButtonSecondaryColor");
    var secondaryButtonTitleColor = appManager.getColorForKey("ButtonSecondaryTitleColor");
    var secondaryButtonBorderColor = appManager.getColorForKey("ButtonSecondaryBorderColor");

    var phoneLabel = locManager.localizedStringForKey("PHONE_OPTION") + ":";
    var closedLabel = locManager.localizedStringForKey("CLOSED_LABEL");

    var markerTitle = locManager.localizedStringForKey("MARKER_YOUR_LOCATION_TITLE");
    var markerBody = locManager.localizedStringForKey("MARKER_YOUR_LOCATION_BODY");
    var selectedLocation = this.state.selectedLocation == null ? (locations.length > 0 ? locations[0] : null) : this.state.selectedLocation;
    var markers = this.state.markers;

    var selectedRegion = this.state.selectedRegion;
    if( selectedLocation != null && selectedRegion == null )
    {
      var latitude = parseFloat(selectedLocation.Latitude);
      var longitude = parseFloat(selectedLocation.Longitude);

      selectedRegion =
      {
        latitude:latitude,
        longitude:longitude,
        latitudeDelta:0.002,
        longitudeDelta:0.002,
      }
    }

    var AccentColoredFab = MKButton.accentColoredFab()
      .withStyle(styles.callButton)
      .build();
      // MapView key={"map"} annotations={annotations} style={[styles.mapView]} {...otherProps} />
    return (
      <View style={[styles.container,{backgroundColor:generalColor, flexDirection:'column'}]}>
        { this.props.extras && this.props.extras.shouldHideActionBar ? null : <View style={styles.actionBarSpacer} /> }
        { Platform.OS != 'web' ? <View style={{height: locations.length <= 0 ? 0 : 200}} /> : null}
        <ReUpScrollView ref={(a)=>this._ptr = a} style={styles.locationList} bounces={true} responder={this} isEmpty={locations.length <= 0} featureName="Locations" >
          {
            locations.map(function(location, index)
            {
              if( index > 2 && !thisThing.state.showingAll ) return null;

              var hours = typeof location.Hours !== 'undefined' && location.Hours != null && location.Hours.length > 0 ? JSON.parse(location.Hours) : [];

              return (
                <View key={"locrow-"+location.LocationID}>
                <View>
                <MKButton key={location.LocationID}
                  backgroundColor={'transparent'}
                  shadowRadius={2}
                  shadowOffset={{width:0, height:2}}
                  shadowOpacity={0.7}
                  shadowColor={'transparent'}
                  onPress={() => {
                    thisLocations.didSelectLocation(location);
                  }} style={styles.rowContainer}>
                  <View style={styles.row}>
                    <View style={styles.topContainer}>
                      <Icon style={styles.mapIcon} name={"map-marker"} size={25} color={secondaryButtonTitleColor} />
                      <View style={styles.infoContainer}>
                        <ReUpText appManager={appManager} style={{color:generalTitleColor, fontSize:22}}>
                          {location.Name}
                        </ReUpText>
                        <ReUpText appManager={appManager} style={{paddingTop:4, color:generalTitleColor}}>
                          {location.Address}
                        </ReUpText>
                        <ReUpText appManager={appManager} style={styles.phone}>
                          {phoneLabel + " " + location.Phone}
                        </ReUpText>
                      </View>
                    </View>
                  </View>
                </MKButton>

                <View style={styles.buttonContainer}>
                  <AccentColoredFab
                    backgroundColor={secondaryButtonColor}
                    shadowRadius={2}
                    shadowOffset={{width:0, height:0}}
                    shadowOpacity={0}
                    shadowColor={secondaryButtonBorderColor}
                    style={styles.callButton}
                    onPress={() => {
                      thisLocations.callLocation(location);
                    }}>
                    <Icon style={styles.callIcon} name={"phone"} size={25} color={secondaryButtonTitleColor} />
                  </AccentColoredFab>
                </View>
                </View>
                {
                  !isNaN(location.distance) ?
                  <View style={{flexDirection: 'row', justifyContent: 'flex-end', marginRight: 0}}>
                    <View style={{flex: 1, height:70, flexDirection: 'row', alignItems: 'center', marginLeft: 20}}>
                      <ReUpText appManager={typeof appManager === 'undefined' ? null : appManager} style={{color:generalTitleColor, marginLeft: 15}}>
                        {
                          locManager.localizedDistance(location.distance*1000)
                        }
                      </ReUpText>
                    </View>
                    <View style={[styles.buttonContainer, {height:50}]}>
                      <AccentColoredFab
                        backgroundColor={secondaryButtonColor}
                        shadowRadius={2}
                        shadowOffset={{width:0, height:0}}
                        shadowOpacity={0}
                        shadowColor={secondaryButtonBorderColor}
                        style={styles.callButton}
                        onPress={() => {
                          thisLocations.openMaps(location);
                        }}>
                        <Icon style={styles.callIcon} name={"compass"} size={25} color={secondaryButtonTitleColor} />
                      </AccentColoredFab>
                    </View>

                  </View>
                  : null
                }
                {
                  typeof hours === 'undefined' || selectedLocation == null || selectedLocation.LocationID != location.LocationID ?
                  <View />
                  :
                  <View style={styles.hours}>
                    {
                      hours.map(function(hour, index)
                      {
                        var isClosed = !hour.isActive;
                        var dayName = locManager.nameOfDay((index+1)%7);
                        var time = isClosed ? closedLabel : locManager.localizedTime(hour.timeFrom) + " - " + locManager.localizedTime(hour.timeTill);
                        return (
                          <View style={styles.hour}>
                            <ReUpText appManager={appManager} style={[styles.dayText, {color:generalTitleColor}]}>
                              {dayName}
                            </ReUpText>
                            <ReUpText appManager={appManager} style={[styles.time, {color:generalTitleColor}]}>
                              {time}
                            </ReUpText>
                          </View>
                        )
                      })
                    }
                  </View>
                }
                <View style={styles.divider} />
                </View>
              )
            })
          }
          {
            !this.state.showingAll && locations.length > 2 ?
              <ReUpButton isSecondary={true} onPress={()=>
                {
                  this.setState({showingAll:true})
                }} style={{marginVertical:10, marginHorizontal:20}} appManager={appManager} text={titleCase(locManager.localizedStringForKey("MORE_LABEL"))} />
            : null
          }
        </ReUpScrollView>

        {
          locations.length !== 0 ?
          <MapView key="mapview"
            region={this.state.region}
            onRegionChange={this.onRegionChange}
            style={[styles.mapView, {position:'absolute', left:0, right:0, top:this.props.extras && this.props.extras.shouldHideActionBar ? 0 : Globals.ACTION_BAR_HEIGHT, height:200}]}
          >
            {markers.map(marker => (
              <MapView.Marker
                coordinate={marker.latlng}
                title={marker.title}
                description={marker.description}
              />
            ))}
            <MapView.Marker
              coordinate={thisLocations.state.currentPosition}
              title={markerTitle}
              description={markerBody}
              pinColor='blue'
            />
          </MapView>
          : null
        }

      </View>
    );
  }
});

var styles = StyleSheet.create({
  container:{
    flex: 1,
    alignItems: 'stretch',
    flexDirection: 'column',
  },
  actionBarSpacer: {
    height:Globals.ACTION_BAR_HEIGHT,
  },
  mapView: {
    flex:1,
    borderColor: '#000000',
  },
  locationList: {
    flex:1,
  },
  divider: {
    marginTop:10,
    height:1,
    backgroundColor:'#DADADA'
  },
  row:{
    padding:10,
    paddingBottom:0,
  },
  phone:{
    paddingTop:4,
    paddingBottom:4,
  },
  hour:{
    paddingLeft:20,
    paddingRight:20,
    flexDirection:'row',
  },
  dayText:{
    fontStyle:'italic',
    flex:1,
  },
  time:{
    fontStyle:'italic',
    flex:1,
    textAlign:'right'
  },
  topContainer:{
    flexDirection:'row',
    marginRight:60
  },
  infoContainer:{
    flex:1,
  },
  buttonContainer:{
    width:50,
    alignItems:'flex-end',
    position:'absolute',
    right:10,
    top:10,
  },
  callButton:{
    position:'absolute',
    borderRadius:25,
    width:50,
    height:50,
    alignItems: 'center',
    justifyContent: 'center',
    textAlign: 'center',
  },
  mapIcon:{
    marginTop: 5,
    marginRight: 10
  }
});

Locations.dataDependencies = ["Locations"];

module.exports = Locations;



// WEBPACK FOOTER //
// ./src/Locations.js